module.exports = __webpack_public_path__ + "img/1-3.d843ea25.svg";